module.exports = __webpack_public_path__ + "media/Kiss.c7c1bf96.mp3";